<template>
  <div
    class="edit-steps"
  >
    <v-alert
      v-if="qerr"
      icon="cloudalert"
      prominent
      text
      type="error"
    >{{ qerr }}</v-alert>

    <draggable
      v-bind="dragOptions"
      :class="{ longbottom: onMove }"
      :clone="clone"
      :list="v"
      :move="onMoveCallback"
      class="edit-steps__wrapper"
      drag-class="dragging-item"
      group="steps"
      @change="changed"
    >
      <div
        v-for="(item, key) in v" :key="pos(key)">
        <EditStep :item="item" :skey="key"
          :cursorpos="cursorpos"
          :debug="debug"
          :paused="paused"
          :prefix="prefix"
          :queues="queues"
          :simbundle="simbundle"
          :simulator="simulator"
          :steps="steps"
          :variables="variables"
          :stepcount="v.length"
          @disableSimulator="simulator = false; debug = false"
          @moveUpOrDown="moveUpOrDown">
            <div v-if="item.module == 'loop'" class="col-12">
              <Queue v-if="item.loop" :item="item.loop && item.loop.steps[0]" :prefix="prefix+':'+key" skey="-1" :simbundle="simbundle" :simulator="simulator" :debug="debug" :queues="queues" :paused="paused" />
              <EditSteps
                v-model="item.loop.steps"
                :cursorpos="cursorpos"
                :debug="debug"
                :paused="paused"
                :prefix="prefix+':'+key"
                :queues="queues"
                :simbundle="simbundle"
                :simulator="simulator"
                :steps="steps"
                :variables="variables"
                type="loop"
                @disableSimulator="simulator = false;debug = false;"
              />
            </div>

            <div v-if="item.module == 'ifstep'"  class="col-12">
              <Queue v-if="item.ifstep" :item="item.ifstep && item.ifstep.steps[0]" :prefix="prefix+':'+key" skey="-1" :simbundle="simbundle" :simulator="simulator" :debug="debug" :queues="queues" :paused="paused" />
              <EditSteps
                v-model="item.ifstep.steps"
                :cursorpos="cursorpos"
                :debug="debug"
                :paused="paused"
                :prefix="prefix+':'+key"
                :queues="queues"
                :simbundle="simbundle"
                :simulator="simulator"
                :steps="steps"
                :variables="variables"
                type="if statement"
                @disableSimulator="simulator = false;debug = false;"
              />
            </div>
        </EditStep>
        <Queue :item="item" :prefix="prefix" :skey="key" :simbundle="simbundle" :simulator="simulator" :debug="debug" :queues="queues" :paused="paused" />
      </div>
      <div class="dropZone" :class="{ hidden: onMove }" v-if="value.length > 0">Drag <a @click="$root.$emit('add-step-sidebar')">additional steps</a> here, or into the list above</div>
      <div class="dropZone" :class="{ hidden: onMove }" v-if="value.length === 0">Drag <a @click="$root.$emit('add-step-sidebar')">a step</a> here.</div>
    </draggable>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import draggable from "vuedraggable";

const arrayMove = require('array-move');

export default {
  name: "EditSteps",
  components: {
    draggable,
    Queue: () => import("@/components/Editor/Queue"),
    EditStep: () => import("@/components/Editor/EditStep"),
  },
  display: "Nested",
  props: [
    "cursorpos",
    "debug",
    "inputs",
    "paused",
    "prefix",
    "queues",
    "simbundle",
    "simulator",
    "steps",
    "tasks",
    "type", // used when nested to show correct message i.e. loop OR if statement
    "value",
    "variables",
  ],
  data: () => ({
    extra: "",
    modal: false,
    modalKeys: {},
    onMove: false,
    qerr: "",
    qindex: 0,
    qitem: "",
    qmodal: false,
    qmodalKeys: {},
    qstep: "",
    selectedStep: {},
  }),
  computed: {
    ...mapState({
      datamapper: state => state.datamapper,
    }),
    dragOptions() {
      return {
        animation: 200,
      };
    },
    v: {
      set: function (nv) {
        this.$emit("input", nv);
      },
      get: function () {
        return this.value;
      },
    },
  },
  mounted() {
    this.$root.$on('on-move', this.setOnMove);
  },
  methods: {
    moveUpOrDown({oldPos, newPos}) {
      this.v = arrayMove(this.v, oldPos, newPos);
    },
    pos(key) {
      return (this.prefix ? this.prefix + "." : "") + key;
    },
    getIcon(mod) {
      return "/img/icons/step_"+ mod +".svg";
    },
    disableSimulator() {
      this.$root.$emit("sim-disable");
    },
    onMoveCallback(evt) {
      this.onMove = true;
      this.$root.$emit("sim-disable");
      this.$root.$emit("drag-event", evt);
      return true;
    },
    clone(v) {
      this.onMove = false;
      this.$root.$emit("step-add", v);
      return v;
    },
    changed(a) {
      const pos = a.added.newIndex
      this.$root.$emit('cursor-move', { pos: `steps.${pos}` })
      this.$root.$emit("step-changed");
    },
    setOnMove(v) {
      this.onMove = v.onMove;
    },
  },
};
</script>

<style lang="scss">
.dragging-item {
  border: 2px dashed var(--apio-purple) !important;
}

.edit-steps {
  &__no-steps-added {
    border-radius: 2px;
    border: 2px dotted var(--apio-shade-4);
    color: var(--apio-shade-3);
    margin-top: 16px;
    padding: 16px;
    font-size: var(--font-h3-size);
    margin-right: 24px;
    min-height: 100px;

    @media screen and (max-width: 1024px) {
      margin-right: 0;
      font-weight: var(--font-extra-bold);
      font-size: var(--font-paragraph-2-size);
    }
  }

  &__wrapper {
    margin-right: 24px;
    @media screen and (max-width: 1024px) {
      margin-right: 0;
    }
  }
}

.longbottom {
  padding-bottom: 100px;
}

.dragArea {
  border-radius: 4px;
  border: 2px dashed var(--apio-purple);
  min-height: 72px;
  padding: 8px !important;
}

.dropZone {
  background-color: var(--apio-shade-5);
  border-radius: 2px;
  border: 2px dotted var(--apio-shade-4);
  color: var(--apio-shade-3);
  font-size: var(--font-h3-size);
  font-weight: var(--font-semi-bold);
  padding: 16px;
}

ul {
  padding-bottom: 72px !important;
}

li {
  list-style: none;
}

.hidden {
  display: none;
}
</style>
